// WorkflowShowcase.jsx - One-tap workflows (Core Differentiator)
import React, { useState } from 'react';
import './WorkflowShowcase.css';
import landingData from '../data/landingData.json';
import { AnimationVariant, BeforeAfterPreview } from '../../homeScreen/components/BeforeAfterPreview';
import SimpleBeforeAfter from '../../homeScreen/components/SimpleBeforeAfter';

const WorkflowShowcase = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const { workflows, workflowCategories } = landingData;

  const filteredWorkflows = activeCategory === 'All' 
    ? workflows 
    : workflows.filter(w => w.category === activeCategory);

  const handleOpenWorkflow = () => {
    window.location.href = 'https://account.fluxuro.ai';
  };

  return (
    <section id="workflows" className="workflows-section">
      <div className="workflows-header">
        <h2 className="section-title">One-tap workflows</h2>
        <p className="section-subtitle">
          Built for product marketing, brand content, and viral formats.
        </p>
      </div>

      <div className="category-pills">
        {workflowCategories.map((cat) => (
          <button
            key={cat}
            className={`category-pill ${activeCategory === cat ? 'active' : ''}`}
            onClick={() => setActiveCategory(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      <div className="workflows-carousel">
        {filteredWorkflows.map((workflow, index) => (
          <div key={index} className="workflow-card" onClick={handleOpenWorkflow}>
            <div className="workflow-image">
              <SimpleBeforeAfter
                before={workflow.beforeImage}
                after={workflow.afterImage}
                animationVariant={AnimationVariant.SLIDE}
                className="workflow-preview"
              />
              <span className="workflow-badge">1-Tap</span>
            </div>
            <div className="workflow-info">
              <h3 className="workflow-name">{workflow.name}</h3>
              <span className="workflow-cta">Open in Zen →</span>
            </div>
          </div>
        ))}
      </div>

      <button className="btn-secondary view-more-btn" onClick={handleOpenWorkflow}>
        Explore 100+ more
      </button>
    </section>
  );
};

export default WorkflowShowcase;
